import React, { useEffect } from "react";

const useSafariBug = () => {
  useEffect(() => {
    const handleResize = () => {
      let height = window.visualViewport?.height || window.innerHeight;

      // Safari workaround to ensure correct height during scroll/resize
      if (
        navigator.userAgent.includes("Safari") &&
        navigator.userAgent.includes("Mobile")
      ) {
        height = Math.min(
          window.innerHeight,
          window.visualViewport?.height || height
        );
      }

      document.documentElement.style.setProperty("--vh", `${height * 0.01}px`);
      window.scrollTo({ top: 0, behavior: "instant" });
      document.onscroll = () => {};
    };

    // handleResize(); // Call on initial load

    // if (window.visualViewport) {
    //   window.visualViewport.addEventListener("resize", handleResize);
    //   window.visualViewport.addEventListener("scroll", handleResize); // Safari triggers UI changes when scrolling
    // } else {
    //   window.visualViewport.addEventListener("scroll", handleResize);
    //   window.addEventListener("resize", handleResize);
    // }

    // return () => {
    //   if (window.visualViewport) {
    //     window.visualViewport.removeEventListener("resize", handleResize);
    //     window.visualViewport.removeEventListener("scroll", handleResize);
    //   } else {
    //     window.removeEventListener("resize", handleResize);
    //   }
    // };
  }, []);
};

export default useSafariBug;
